import { Component, OnInit, OnDestroy } from '@angular/core';
import { SmsMessage } from '../../../lib';
import { ChatMessengerService } from '../chat-messenger.service';
import { Subscription } from 'rxjs';

export enum FilterType {
  all = 'all',
  workgroupQueue = 'workgroupQueue',
  agentName = 'agentName'
}

export interface ChatFilter {
  value: string;
  type: FilterType;
}

export const AllFilter: ChatFilter = { value: 'All', type: FilterType.all };

@Component({
  selector: 'app-chat-filter',
  templateUrl: './chat-filter.component.html',
  styleUrl: './chat-filter.component.scss'
})
export class ChatFilterComponent implements OnInit, OnDestroy {
  currentFilter: ChatFilter = AllFilter;
  messages!: SmsMessage[];
  rawFilterEntries: ChatFilter[] = [];
  filterEntries: ChatFilter[] = [];
  selectedFilter!: ChatFilter;
  selectedFilterIndex: number = 0;
  messagesSubscription!: Subscription;
  currentStudentId: number | undefined = undefined;
  searchString: string = '';
  searchActive: boolean = false;

  constructor(
    private messenger: ChatMessengerService
  ) { }

  ngOnInit(): void {
    this.messagesSubscription = this.messenger.smsMessages.subscribe(messages => {
      this.messages = messages;
      this.clearSearch();
      this.getRawFilterEntries();
    });
    
    this.messenger.chatFilter.subscribe(filter => {
      if (this.currentFilter.type !== filter.type || this.currentFilter.value !== filter.value) {
        this.currentFilter = filter;
        this.setSelectedFilter();
      }
    });
  }

  getRawFilterEntries(): void {
    this.rawFilterEntries = [];
    const workgroupQueues = new Set(this.messages.map(msg => msg.workgroupQueue));
    const agents = new Set(this.messages.map(msg => msg.agentName));

    workgroupQueues.forEach(wgq => {
      if (wgq !== null && wgq !== undefined) {
        this.rawFilterEntries.push({
          value: wgq,
          type: FilterType.workgroupQueue
        });
      }
    });

    agents.forEach(agent => {
      if (agent !== null && agent !== undefined) {
        this.rawFilterEntries.push({
          value: agent,
          type: FilterType.agentName
        });
      }
    });

    this.rawFilterEntries.splice(0, 0, AllFilter);
    this.filterEntries = this.rawFilterEntries.slice();

    this.setSelectedFilter();
  }

  setSelectedFilter(): void {
    this.selectedFilterIndex = this.rawFilterEntries.findIndex(filter => filter.value === this.currentFilter.value);
    this.selectedFilter = this.selectedFilterIndex === -1 ? this.rawFilterEntries[0] : this.rawFilterEntries[this.selectedFilterIndex];
  }

  ngOnDestroy(): void {
    this.messagesSubscription.unsubscribe();
  }

  filterSelected(index: number): void {
    this.selectedFilterIndex = index;
    this.selectedFilter = this.filterEntries[index];
    this.currentFilter = this.selectedFilter;
    this.messenger.setChatFilter(this.selectedFilter);
  }

  checkForEnterKey(event: KeyboardEvent): boolean {
    if (event.key === 'Enter') {
      if (this.searchString.length > 0) {
        this.search();
      }

      return false;
    } else {
      return true;
    }
  }

  search(): void {
    const lowerCaseSearchString = this.searchString.toLowerCase();

    this.filterEntries = this.rawFilterEntries.filter(filter => {
      return filter.value.toLowerCase().includes(lowerCaseSearchString);
    });

    this.selectedFilterIndex = -1;
    this.searchActive = true;
  }

  clearSearch(): void {
    this.filterEntries = this.rawFilterEntries.slice();
    this.searchString = '';
    this.searchActive = false;

    this.setSelectedFilter();
  }
}
